import { useMutation } from '@tanstack/react-query';
import {
  createSupportTicket,
  createPublicSupportTicket,
  verifySupportTicket,
} from '@/services/support-service/support-service';
import {
  SupportTicketRequest,
  PublicSupportTicketRequest,
} from '@/services/support-service/support-service.types';

export const useSupport = () => {
  const {
    mutate: submitSupportTicket,
    isPending: isSubmittingTicket,
    isSuccess: isTicketSubmitted,
    isError: isTicketError,
    error: ticketError,
    data: ticketData,
    reset: resetTicket,
  } = useMutation({
    mutationFn: (data: SupportTicketRequest) => createSupportTicket(data),
  });

  const {
    mutate: verifyTicket,
    isPending: isVerifying,
    isSuccess: isVerified,
    isError: isVerificationError,
    error: verificationError,
    data: verificationData,
  } = useMutation({
    mutationFn: (token: string) => verifySupportTicket(token),
  });

  return {
    submitSupportTicket,
    isSubmittingTicket,
    isTicketSubmitted,
    isTicketError,
    ticketError,
    ticketData,
    resetTicket,
    verifyTicket,
    isVerifying,
    isVerified,
    isVerificationError,
    verificationError,
    verificationData,
  };
};

export const usePublicSupport = () => {
  const {
    mutate: submitPublicTicket,
    isPending: isSubmittingTicket,
    isSuccess: isTicketSubmitted,
    isError: isTicketError,
    error: ticketError,
    data: ticketData,
    reset: resetTicket,
  } = useMutation({
    mutationFn: (data: PublicSupportTicketRequest) => createPublicSupportTicket(data),
  });

  return {
    submitPublicTicket,
    isSubmittingTicket,
    isTicketSubmitted,
    isTicketError,
    ticketError,
    ticketData,
    resetTicket,
  };
};
